import React, { useRef, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { useSelector } from 'react-redux';
//import { NewEmployeeReportState } from '../../../interface/NewEmployeeReportInterface';
import { numberWithCommas, isAgg } from "../../Common/Helpers";
import { ReportContainer, ReportContent } from './EarlyCareerReport';
import { Heading1, Heading2, ReportText, TextLink, TextRouteLink, TextSpan } from '../../Common/SharedStyledComponents';
import LoadingSpinner from '../../Common/LoadingSpinner';
import { withUserActionTracker } from '../../../sharedUtilities/UserActionTracker';


const Methodology = ({ }) => {

    const topOfPageRef = useRef(null);

    useEffect(() => {
        topOfPageRef.current.scrollIntoView({ behavior: 'smooth'});
    }, []);

    const history = useHistory();
    //const employeeProfileReportState: NewEmployeeReportState = useSelector(state => state.newEmployeeReportProperties);

    //const reportDisplayId = useSelector(state => state.userProperties.report_display_id)
    //const { university } = employeeProfileReportState.EmployeeProfileInfo;
    //const employeeProfileReportMethodology = employeeProfileReportState.EmployeeMethodology;

    //const isAggregate = isAgg(reportDisplayId);

    //if (!employeeProfileReportMethodology) return <LoadingSpinner loadingText="Loading report methodology ..." />

    //const { start_year, end_year, num_SB, num_emp_umetrics, num_emp_base, sb_emp_pct, non_leavers_pct, non_us_pct, emp_pct, sb_emp_avg } = employeeProfileReportMethodology;

    //const rateComparison = `This rate is ${sb_emp_pct == sb_emp_avg ? 'about the same as' : sb_emp_pct < sb_emp_avg ? 'lower than' : 'higher than'} that for other IRIS universities.`;

    return (
        <ReportContainer>
            <ReportContent className="col-md-12 col-lg-12">
            </ReportContent>
        </ReportContainer>
    );

}

export default withUserActionTracker(Methodology, "Early Career Report", "viewed methodology page");